/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Row, Col, Select,
} from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Countries from './Countires';
import {
  FormItem,
  FormInput,
  ItemLabel,
} from './Forms';
import { FlowType, Field } from '../types';

const { Option } = Select;

const FormCompanyData = ({
  form, disabledCountrySelect, regionFormConfig, flowType,
}) => {
  const { t } = useTranslation();
  const region = regionFormConfig.code;

  const replaceCountryCodeInVatNumber = (countryCode) => {
    const newTaxNumber = form.getFieldValue(Field.VAT_NUMBER).replace(/^[A-Za-z]{0,2}/, countryCode);
    form.setFieldsValue({ [Field.VAT_NUMBER]: newTaxNumber });
  };

  return (
    <>
      <Row>
        <Col span={22}>
          <Row>
            <FormItem
              marginBottom="-16px"
              labelCol={{ span: 24 }}
              label={(<ItemLabel>{t('FORM_FILL_COMPANY.COMPANY_NAME_HEADER')}</ItemLabel>)}
              name={Field.COMPANY_NAME}
              style={{
                width: '100%',
                display: 'block',
                marginBottom: '0px',
              }}
              rules={[
                {
                  required: false,
                  type: 'string',
                  max: 100,
                  message: t('COMMON.VALIDATION.MAX_100_COMPANY'),
                },
                {
                  required: true,
                  type: 'string',
                  min: 3,
                  message: t('COMMON.VALIDATION.MIN_3_COMPANY'),
                },
              ]}
            >
              <FormInput placeholder={flowType === FlowType.ONBOARDING
                ? t(`FORM_FILL_COMPANY.CARRIER_NAME_MASK_${region}`)
                : t('FORM_FILL_COMPANY.COMPANY_NAME_MASK')}
              />
            </FormItem>
          </Row>
          <Row>
            <Col span={5}>
              <FormItem
                marginBottom="-16px"
                labelCol={{ span: 24 }}
                label={(
                  <ItemLabel>
                    {t('FORM_FILL_COMPANY.TAX_CODE_HEADER')}
                  </ItemLabel>
                )}
                name={Field.VAT_COUNTRY_CODE}
                initialValue={regionFormConfig.fields.countryCode.defaultFieldValue}
                style={{ width: '95%', marginBottom: '5px' }}
                rules={[
                  {
                    required: true,
                    message: t('COMMON.VALIDATION.SELECT_FROM_THE_LIST'),
                  },
                ]}
              >
                <Select
                  style={{
                    fontSize: '12px',
                  }}
                  disabled={disabledCountrySelect}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  onChange={(value) => {
                    replaceCountryCodeInVatNumber(value);
                  }}
                >
                  {Countries.getCountries.map((obj) => <Option key={obj.code} value={obj.code}>{obj.code}</Option>)}
                </Select>
              </FormItem>
            </Col>
            <Col span={19}>
              <FormItem
                marginBottom="-16px"
                labelCol={{ span: 24 }}
                label={<ItemLabel>{t('FORM_FILL_COMPANY.ADDRESS_HEADER')}</ItemLabel>}
                name={Field.COMPANY_ADDRESS}
                style={{ width: '100%', display: 'block', marginBottom: '5px' }}
                rules={[
                  {
                    required: false,
                    type: 'string',
                    max: 200,
                    message: t('COMMON.VALIDATION.MAX_200'),
                  },
                  {
                    required: true,
                    type: 'string',
                    min: 3,
                    message: t('COMMON.VALIDATION.MIN_3_COMPANY_ADDRESS'),
                  },
                ]}
              >
                <FormInput placeholder={t(`FORM_FILL_COMPANY.ADDRESS_MASK_${region}`)} />
              </FormItem>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default FormCompanyData;

FormCompanyData.propTypes = {
  form: PropTypes.any.isRequired,
  disabledCountrySelect: PropTypes.bool.isRequired,
  regionFormConfig: PropTypes.any.isRequired,
  flowType: PropTypes.oneOf(Object.values(FlowType)).isRequired,
};
